import { render, staticRenderFns } from "./bfhs-tile.vue?vue&type=template&id=7aa18e44&scoped=true"
import script from "./bfhs-tile.vue?vue&type=script&setup=true&lang=js"
export * from "./bfhs-tile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bfhs-tile.vue?vue&type=style&index=0&id=7aa18e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa18e44",
  null
  
)

export default component.exports